module.exports = __webpack_public_path__ + "img/Lin.ba65cee7.png";